import { Div, ElementProperties, Table, TD, TR, TH } from 'alkali'
import StudyContext from 'components/extract/model/StudyContext'
import Icon from 'components/Icon'
import ValueComposer from 'lib/compose/ValueComposer'
import * as positiveIcon from 'icons/monitor-heart-rate-up.svg'
import * as negativeIcon from 'icons/monitor-heart-rate-down.svg'
import * as note from 'icons/notes-paper-text.svg'
import * as _ from 'lodash'

interface SummaryTabOpts extends ElementProperties<SummaryTab> {
	study: StudyContext
}

/**
 * Simple summary table for current study data
 */
export default class SummaryTab extends Div('.char-summary') {
	created(props: SummaryTabOpts) {
		const { study } = props
		const groupsById = _.keyBy(study.study?.groups || [], 'Id')
		const sections = study.study?.Sections || {}
		const rows = _.flatMap(sections, (section, type) =>
			buildSection(type, (section.Rows || []).flatMap(row =>
				buildRow(row, (row.Cells || []).map(cell =>
					buildCell(row, cell, groupsById[cell.Group])
				))
			))
		)
		props.content = [
			Table([
				TR([
					TH('Type'),
					TH('Name'),
					TH('Group'),
					TH('N'),
					TH('Value'),
					TH()
				]),
				...rows.map(r => TR([r]))
			])
		]
	}
}


const buildCell = (row, cell, group) => [
	TD({ title: group?.Id }, group?.Name || group?.OriginalName || ''),
	TD({ title: cell?.N || group?.N || ''}, cell?.N || group?.N || ''),
	TD('.value-cell', { title: cell?.Id }, cell ? ValueComposer.compose({
		...cell,
		Row: {
			...row,
			Name: typeof row.Name == 'string' ? { Name: row.Name, UnboundName: row.Name } : row.Name
		}
	}) : '')
]

const wrapCol = (prepend = [], rows, append = []) => rows.map((row, i) =>
	i == 0 ? [
		...prepend,
		...row,
		...append
	] : row
)

const buildRow = (row, cellRows) => wrapCol([
	TD({ attributes: { rowspan: cellRows.length } }, [
		Div('.ext-hist-info', [
			Div('.ext-hist-outcome', { title: `${row.Type}: ${row.FieldType}` }, [
				row.Name,
				row.IsPositive == null ? undefined :
					Icon({
						title: row.IsPositive == null ? 'Unspecified (assume negative)' : row.IsPositive == true ? 'Positive' : 'Negative',
						icon: row.IsPositive ? positiveIcon : negativeIcon
					}),
				row?.Time?.FollowUp ? ' @' + row.Time.Gestalt : undefined,
				(row.Definition) ? Icon({ icon: note, title: row.Definition }) : undefined
			])
		])
	])
], cellRows)

const buildSection = (type, rowRows) => wrapCol([
	TD({ attributes: { rowspan: rowRows.length } }, type)
], rowRows)